// var isNode = false; FIXME: Browserify/minifyify has issues with the next link
// var transport = (isNode) ? require('./node-http-transport') : require('./ajax-http-transport');
import transport from './ajax-http-transport';
export default transport;



// WEBPACK FOOTER //
// ./src/transport/http-transport-factory.js